var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10142 16.526L14.021 8.60646L9.3945 3.97998L1.47493 11.8995L0.0203192 17.3645C-0.0503913 17.617 0.0910296 17.7887 0.151639 17.8493C0.212248 17.9099 0.383973 18.0514 0.63651 17.9806L6.10142 16.526Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0006 4.41435C18.0006 4.28303 17.9501 4.15171 17.8491 4.0608L13.9398 0.151522C13.8489 0.060609 13.7176 0 13.5862 0C13.4549 0 13.3236 0.0505075 13.2327 0.151522L10.1113 3.27288L14.7378 7.89937L17.8592 4.77801C17.9501 4.68709 18.0107 4.55577 18.0107 4.42445L18.0006 4.41435Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b86712dfdaed48964eb4009e0c2ea637.svg";
export { ForwardRef as ReactComponent };